(function () {
  'use strict';

  var drawerReady = false;
  var productReady = false;
  var pendingDrawer = null;
  var pendingCard = null;

  function isDesktop() {
    return window.matchMedia ? window.matchMedia('(min-width: 768px)').matches : true;
  }

  function shouldBlockDrawerClick(target) {
    if (!target || !target.closest) return null;
    return target.closest('[data-drawer-options]');
  }

  function getProductCard(target) {
    if (!target || !target.closest) return null;
    return target.closest('.t4s-product-1, .t4s-product-one, .t4s-product-11');
  }

  function cardCanOpenPopup(card) {
    if (!card) return false;
    if (isDesktop()) return !!card.querySelector('[data-action-quickview]');
    return !!card.querySelector('.t4s-p1-atc-bottom-panel');
  }

  function isExcludedControl(target) {
    return !!target.closest(
      '.t4s-pr-wishlist, [data-action-wishlist], .t4s-pr-compare, [data-action-compare], .t4s-product-btns2 a, .t4s-product-btns2 button, .t4s-product-colors, .t4s-pr-color__item, .t4s-product-variant-thumbs, [data-variant-thumb], [data-variant-thumbs-more], .t4s-product-sizes, .t4s-product-size, .t4s-p1-atc-bottom-panel, .t4s-p1-atc-trigger'
    );
  }

  function openProductCard(card) {
    if (!card) return;
    if (typeof window.__t4sOpenProductCard === 'function') {
      window.__t4sOpenProductCard(card);
      return;
    }
    var qvBtn = card.querySelector('[data-action-quickview]');
    if (qvBtn) {
      window.__t4sOpeningQv = true;
      try {
        qvBtn.click();
      } finally {
        window.__t4sOpeningQv = false;
      }
    }
  }

  function replayDrawer() {
    if (!drawerReady || !pendingDrawer) return;
    var el = pendingDrawer;
    pendingDrawer = null;
    window.setTimeout(function () {
      el.click();
    }, 0);
  }

  function replayProduct() {
    if (!productReady || !pendingCard) return;
    var card = pendingCard;
    pendingCard = null;
    window.__t4sPendingProductCard = null;
    window.setTimeout(function () {
      openProductCard(card);
    }, 0);
  }

  document.addEventListener(
    'click',
    function (e) {
      if (!drawerReady) {
        var drawerEl = shouldBlockDrawerClick(e.target);
        if (drawerEl) {
          e.preventDefault();
          e.stopPropagation();
          pendingDrawer = drawerEl;
          return;
        }
      }

      /* 程序化打开 QV：只挡默认跳转 */
      if (window.__t4sOpeningQv) {
        e.preventDefault();
        return;
      }

      var card = getProductCard(e.target);
      if (!card || !cardCanOpenPopup(card) || isExcludedControl(e.target)) return;

      var isNavLink = !!e.target.closest('[data-pr-href], [data-action-quickview], .t4s-pr-quickview');
      if (!isNavLink) {
        /* 手机点卡片空白：未就绪时先排队，就绪后交给 P1 自己的监听 */
        if (!productReady && !isDesktop()) {
          e.preventDefault();
          e.stopPropagation();
          pendingCard = card;
        }
        return;
      }

      /* 永远不让商品链接 / QV 按钮走 href 进详情 */
      e.preventDefault();

      if (!productReady) {
        e.stopPropagation();
        pendingCard = card;
        return;
      }

      /* 已就绪：只 preventDefault，不 stopPropagation，交给页面里的弹窗逻辑 */
    },
    true
  );

  function waitDrawerReady() {
    if (window.jQuery_T4NT && window.T4SThemeSP && T4SThemeSP.Drawer) {
      drawerReady = true;
      replayDrawer();
      return;
    }
    window.setTimeout(waitDrawerReady, 30);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitDrawerReady);
  } else {
    waitDrawerReady();
  }

  window.__t4sEarlyGuard = {
    setProductReady: function () {
      productReady = true;
      window.__t4sProductClickReady = true;
      if (!pendingCard && window.__t4sPendingProductCard) {
        pendingCard = window.__t4sPendingProductCard;
      }
      window.__t4sPendingProductCard = null;
      replayProduct();
    }
  };
})();
